"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * Change of product categories within a product.
 * @author Radek Beran
 */


var ProductCategoryChange =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductCategoryChange, _DomainObject_1$Domai);

  /**
   * @param id unique DB id
   * @param transferLogId id of data transfer (identification of import run)
   * @param productId
   * @param oldCategoryIds List of old product categories. The first one is lowest category, the last one is root.
   * @param newCategoryIds List of new product categories. The first one is lowest category, the last one is root.
   * @param changedFromLevel level of category at which the change has taken place
   */
  function ProductCategoryChange(id, transferLogId, productId, oldCategoryIds, newCategoryIds) {
    var _this;

    _classCallCheck(this, ProductCategoryChange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryChange).call(this));
    _this.id = id;
    _this.transferLogId = transferLogId;
    _this.productId = productId;
    _this.oldCategoryIds = oldCategoryIds;
    _this.newCategoryIds = newCategoryIds;
    var oldFromTop = oldCategoryIds.reverse();
    var newFromTop = newCategoryIds.reverse();
    var commonPrefixLength = utils_1.Utils.lengthOfCommonPrefix(oldFromTop, newFromTop);

    if (commonPrefixLength < oldCategoryIds.size) {
      _this.changedFromLevel = commonPrefixLength + 1;
    } else {
      _this.changedFromLevel = null;
    }

    return _this;
  }
  /**
   * Converter from data-dictionary representation.
   */


  _createClass(ProductCategoryChange, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ProductCategoryChange(mat.id, mat.transferLogId, mat.productId, mat.oldCategoryIds, mat.newCategoryIds);
    }
  }]);

  return ProductCategoryChange;
}(DomainObject_1.DomainObject);

exports.ProductCategoryChange = ProductCategoryChange; // tslint:disable-next-line:member-ordering

ProductCategoryChange.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductCategoryChange.name);
  return {
    id: builder.id('id'),
    transferLogId: builder.id('transferLogId'),
    productId: builder.id('productId'),
    oldCategoryIds: builder.listOf(builder.id('oldCategoryIds')),
    newCategoryIds: builder.listOf(builder.id('newCategoryIds')),
    changedFromLevel: builder.opt(builder.num('changedFromLevel'))
  };
}();